import { render, staticRenderFns } from "./IconGroups.vue?vue&type=template&id=6a6d4e5e"
import script from "./IconGroups.vue?vue&type=script&lang=js"
export * from "./IconGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports